import { render, staticRenderFns } from "./FormCarpeta.vue?vue&type=template&id=2dedcf7c"
import script from "./FormCarpeta.vue?vue&type=script&lang=js"
export * from "./FormCarpeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports